// extracted by mini-css-extract-plugin
export default {"button":"n5D2EjcnwOwhXh3MeyhIYQ==","content":"zVBIPeEQRbamX380H96SFg=="};